import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Typography } from '../Typography/Typography';
import { TypographyVariantModel } from '../Typography/tools/Typography.model';
import { LANGUAGES } from 'common-react';

import useStyles from './PercentChange.style';

const maximumFractionDigits = 2;

function formatPercentChange(change: number) {
  return change.toLocaleString(LANGUAGES.PL, { style: 'percent', maximumFractionDigits });
}

const PercentChange: FunctionComponent<{value: number, className?: string, valueVariant?: TypographyVariantModel}> = ({value, className, valueVariant}) => {
  const c = useStyles({value});

  return <Typography
          variant={valueVariant}
          className={clsx(c.root, className)}
          align='right'
          fontWeight='bold'
        >
          {formatPercentChange(value)}
        </Typography>
};

export { PercentChange, formatPercentChange };
